/**
 * Human-readable label for a filter key/value (for pills).
 * @param {string} key - filter key
 * @param {*} value - filter value
 * @param {Object} options - { occupation, education, maritalStatus, religions }
 */
export function getFilterLabel(key, value, options = {}) {
  if (key === "contactMissing" && value === "yes") return "No contact number";
  if (key === "contactMissing" && value === "has") return "Has contact number";
  if (key === "gender") return value;
  if (key === "name") return `Name: ${value}`;
  if (key === "premium") return value === "yes" ? "Premium" : "Non-Premium";
  if (key === "profileCompletion" && value === "gt70") return "Profile Greater Than 70%";
  if (key === "profileCompletion" && value === "lt70") return "Profile Less Than 70%";
  if (key === "profileCompletion" && value === "pct0") return "Profile 0%";
  if (key === "profileCompletion" && value === "pct1_25") return "Profile 1%-25%";
  if (key === "profileCompletion" && value === "pct26_50") return "Profile 26%-50%";
  if (key === "is_web") return value === "web" ? "Web" : "Mobile";
  if (key === "emailType") {
    return value === "naseebimail" ? "Naseebi Users" : value === "other" ? "Other Users" : value;
  }
  const { occupation = [], education = [], maritalStatus = [], religions = [] } = options;
  if (key === "occupation" && occupation.length) {
    const item = occupation.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "education" && education.length) {
    const item = education.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "marital" && maritalStatus.length) {
    const item = maritalStatus.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "religion" && religions.length) {
    const item = religions.find((o) => String(o.id) === String(value));
    return item ? item.name : value;
  }
  if (key === "created_date_start" || key === "created_date_end") {
    return value
      ? new Date(value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : value;
  }
  return value;
}
